import { createContext } from "react";
import { WarrantyOption } from "~/common/AddToCartModal";

type ExtendedWarrantyModalContextType = {
  showDoNotDisplayOfferButton: boolean | null;
  setShowDoNotDisplayOfferButton: React.Dispatch<
    React.SetStateAction<boolean | null>
  >;
  runAddToCartModalFunctions: boolean;
  setRunAddToCartModalFunctions: React.Dispatch<React.SetStateAction<boolean>>;
  addToCartCloseModal: () => void;
  addToCartSubmitModal: (result: WarrantyOption | undefined) => void;
};

const ExtendedWarrantyModalContext =
  createContext<ExtendedWarrantyModalContextType>({
    showDoNotDisplayOfferButton: false,
    setShowDoNotDisplayOfferButton: () => {},
    runAddToCartModalFunctions: false,
    setRunAddToCartModalFunctions: () => {},
    addToCartCloseModal: () => {},
    addToCartSubmitModal: () => {},
  });
export default ExtendedWarrantyModalContext;
